import { enviroment } from "../../enviroment";

// Admin perf FE-4 (flag REACT_APP_ADMIN_PERF_HELPER_CACHE_ENABLED): the
// helper lists every list screen gates on (all customers / all vendors,
// logo options, design folders) used the global defaults (staleTime 5 s,
// cacheTime 5 min, refetchOnMount false) - so a re-visit after 5 min showed
// a full LoadingView although the rows themselves were cached, and inside
// 5 min a stale list was never revalidated. With the flag on they survive
// 30 min and revalidate ONCE on entry; the user-mutable org lists get a
// 60 s TTL and are invalidated after own mutations (see
// OrganizationRepository). Spread LAST into the useQuery options; off = {}.

const HELPER_CACHE_TIME_MS = 30 * 60_000;
const ORG_LIST_STALE_TIME_MS = 60_000;

type HelperOptions = {
  staleTime?: number;
  cacheTime?: number;
  refetchOnMount?: true;
};

/** all-customers / all-vendors: user-mutable, so a short TTL + revalidate on entry. */
export function helperOrgListOptions(): HelperOptions {
  if (!enviroment.adminPerfHelperCacheEnabled) return {};
  return {
    staleTime: ORG_LIST_STALE_TIME_MS,
    cacheTime: HELPER_CACHE_TIME_MS,
    refetchOnMount: true,
  };
}

/** Catalog-like helpers (logo options, folders): staleTime untouched, long cache + revalidate on entry. */
export function helperCatalogOptions(): HelperOptions {
  if (!enviroment.adminPerfHelperCacheEnabled) return {};
  return { cacheTime: HELPER_CACHE_TIME_MS, refetchOnMount: true };
}
